import angular, { ILogService, IOnChangesObject } from 'angular'
import { TiposDocEstadosStore } from 'src/_candidato/data/tiposStore'
import { IModelCurriculumHistoric } from 'src/model/candidato-api'

class CvHistoricStateInfoComponentCtrl {
  curr!: IModelCurriculumHistoric
  tipos!: TiposDocEstadosStore
  state!: string
  simple!: boolean

  _stateDesc: string

  constructor(private $log: ILogService) {}

  $onInit(): void {
    this.$log.info('[CvHistoricStateInfoComponentCtrl] onInit')
  }

  $onChanges(changes: IOnChangesObject) {
    this.$log.info('----> changes', changes)

    if (changes.state || changes.tipos) {
      this._stateDesc = this._estadoDesc()
    }
  }

  private _estadoDesc() {
    let t = this.tipos && this.tipos.estadosStore().data[this.curr.estado]

    return (t && `${t.estado.texto_en} - ${t.estado.texto_es}`) || this.curr.estado
  }

  get stateDesc() {
    // this.$log.info('[stateDesc]')
    return this._stateDesc
  }
}

angular.module('candidato').component('cvHistoricStateInfo', {
  bindings: {
    curr: '<',
    tipos: '<',
    state: '<',
    simple: '<',
  },
  controller: CvHistoricStateInfoComponentCtrl,
  // templateUrl: "cv-historic-state-info.component.html",
  template: require('./cv-historic-state-info.component.html'),
})
